import { type ReactNode } from 'react';
import { Outlet } from 'react-router';
import { Header } from './header';
import { HelpMenu } from './help';
import { ProfileQuiz } from '@/packages/profile-quiz';
import { FlashToast } from '@/components/flash-toast';

interface LayoutProps {
  children?: ReactNode;
  auth?: boolean;
}

export const Layout = ({ children, auth }: LayoutProps) => {
  return (
    <>
      {!auth && (
        <>
          <Header />
          <ProfileQuiz />
        </>
      )}
      {children ?? <Outlet />}
      <HelpMenu />
      <FlashToast />
    </>
  );
};
